<template>
  <b-container fluid>
    <!-- <b-row>
        <b-col class="mb-4 mt-3">
            <h4><b-icon icon="credit-card-fill"/> Registro de pagos externos </h4>
        </b-col>
    </b-row> -->
    <b-row>
      
      <b-col cols="12" lg="6" class="mt-3">
        Tipo de registro:
       <b-form-select v-model="tipoRegistro" :options="tiposRegistro"></b-form-select>
      </b-col>
      <b-col cols="12" lg="6" class="mt-3" v-if="tipoRegistro.includes('fecha MANUAL')">
        Registrar pagos con la fecha:
       <b-form-input type="date" v-model="fechaPago" ></b-form-input>
      </b-col>
      <b-col cols="12"  class="mt-3">
        Seleccione el archivo a importar
        <b-form-file v-model="file" @change="getBase64" placeholder="Seleccione un archivo .xls"></b-form-file>
      </b-col>
      <b-col cols="12"  class="mt-4">
        <b-button  block variant="success"  @click="enviarLayout">Registrar pagos <b-spinner v-if="procesando"/></b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-textarea
          v-model="this.resultados"
          rows="3"
          max-rows="10"
          disabled
        ></b-form-textarea>
      </b-col>
    </b-row>
  </b-container>
</template>


<script>

import axios from 'axios'
import { server2, checkAuth, getPostConfig, handledError } from '@/axios-tools'
import {getBase64 } from '@/vue-tools'
import { mapState} from 'vuex'

export default {
  computed:{
   ...mapState({
      servicios: state => state.cobro.catalogCobro.serviciosRecaudacion,
      archivoB64: state => state.cobro.archivoB64,
      token: state => state.login.token,
    }),
  },
  data(){
    return{
      fechaPago:'',
      tipoRegistro:'',
      tiposRegistro:['SIIGEM - Registrar ingreso por fecha de PAGO', 'SIIGEM - Registrar ingreso por fecha de CARGA', 'SIIGEM - Registrar ingreso por fecha MANUAL'],
      procesando : false,
      resultados : "",
      file : null
    }
  },
  components: {
  },
  methods:{
    getBase64(evt){
        this.resultados = "";
      /* Método que obtiene la representación en base64 de un archivo y lo guarda en el Array 'archivosB64' */
      getBase64(evt.target.files[0], this.$store);
       
      
    },
    enviarLayout(){
      if( !this.procesando  && checkAuth(this.$router, this.$store) && 
          this.archivoB64.contenido!=null && this.archivoB64.contenido!='' && 
          this.tipoRegistro!='' && ( (this.tipoRegistro.includes('MANUAL') && this.fechaPago!='') || !this.tipoRegistro.includes('MANUAL') )){
        
            this.resultados = "";
            this.procesando = true;
            
            let r ={
              base64: this.archivoB64.contenido,
              extension : this.archivoB64.tipo,
              tipoLayout : this.tipoRegistro,
              op1 : this.fechaPago
            }
	
            axios(
                getPostConfig(server2.cargapagosgem, r, this.token, {})
                
            )
            .then(res => {
                this.resultados = res.data;
                this.procesando = false;
                this.$store.commit("updateArchivoB64", {contenido:'', nombre:'', tipo:''});
                this.file =null;

            }).catch(err => {
                this.procesando = false;
                this.$store.commit("updateArchivoB64", {contenido:'', nombre:'', tipo:''});
                this.resultados = "";
                this.file =null;
                handledError(err, server2.cargapagosgem, this.$router, this.$store);
            });
      }
      
    
    }

  },
   
  
}

</script>
<style>
  
</style>